/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import MarkdownHtml from 'DesignSystem/MarkdownHtml/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/Description"
  
}) {
let appDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'description',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<MarkdownHtml
  viewPath={`${viewPath}/MarkdownHtml`}
 data="app.description"
 markdown={appDescriptionValueData}
 marginTop={dtSpaceXxs}
 color={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}